<template>
    <v-container fluid>
        <v-row class="mb-3">
            <v-col cols="6" sm="5" md="5" lg="3" xl="3"><agregarOrg @reload="listarOrganizaciones" /></v-col>
            <v-spacer></v-spacer>
            <v-col cols="6" sm="4" md="4" lg="3" xl="3">            
                <v-text-field
                    v-model="search"
                    append-icon="mdi-magnify"
                    label="Búsqueda"
                    single-line
                    hide-details>
                </v-text-field>
            </v-col>  
        </v-row>
        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-sheet :height="alturaHoja()" class="v-sheet--offset mx-auto white--text display-1 font-weight-medium text-center" color="#0B3F67" elevation="12" max-width="calc(100% - 32px)">                   
                        <v-layout fill-height align-center justify-center>                            
                            Catálogo Organizaciones
                        </v-layout>                                  
                    </v-sheet>
                    <v-data-table
                        multi-sort
                        :search="search"        
                        :headers="headers"
                        :items="organizaciones"
                        class="elevation-1"
                        :loading="cargando"
                        loading-text="Cargando..."
                        no-data-text="Sin datos"
                        no-results-text="Dato no encontrado"
                        :footer-props="{
                            showFirstLastPage: true,
                            firstIcon:'mdi-page-first',
                            lastIcon: 'mdi-page-last',
                            prevIcon: 'mdi-chevron-left',
                            nextIcon: 'mdi-chevron-right',
                            itemsPerPageText: 'Registros por página',
                            itemsPerPageAllText: 'Todos',
                            showCurrentPage: true,
                            showFirstLastPage: true
                        }">
                        <template v-slot:item.action="{ item }">
                            <modificarOrganizacion @reload="listarOrganizaciones" v-bind:id="item.id"/>
                            <agregarRepLegal @reload="listarOrganizaciones" v-bind:id="item.id"/>
                            <CantInstalCategoria v-bind:id="item.id"/>
                        </template>                        
                        <template v-slot:item.estado="{ item }">
                            <v-layout justify-center>
                                <activarOrganizacion @reload="listarOrganizaciones" v-bind:estado="item.estado" v-bind:id="item.id"/>
                            </v-layout>
                        </template>
                        <template v-slot:item.cluster="{ item }">
                            <v-layout justify-center>
                                <ClusterOrg @reload="listarOrganizaciones" v-bind:cluster="item.cluster" v-bind:id="item.id"/>
                            </v-layout>
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>

import CantInstalCategoria from "@/components/organizaciones/CantInstalCategoriaComponent.vue";
import ActivarOrganizacion from "@/components/organizaciones/ActivarOrganizacionComponent";
import ModificarOrganizacion from "@/components/organizaciones/ModificarOrganizacionComponent";
import AgregarOrg from "@/components/organizaciones/AgregarOrganizacionComponent";
import ClusterOrg from "@/components/organizaciones/ClusterOrgComponent.vue";
import AgregarRepLegal from "@/components/organizaciones/AgregarRepLegal";
import axios from "@/axios.js";

export default {
    components: {
        CantInstalCategoria,
        ActivarOrganizacion,
        ModificarOrganizacion,
        AgregarOrg,
        AgregarRepLegal,
        ClusterOrg
    },
   created() {
        axios.defaults.headers.common['Authorization'] = "Bearer " + this.$store.getters.token;
    },      
    mounted () {
        this.listarOrganizaciones();
    },
    data: () => ({
        headers:[
            {
                text: 'Acciones',
                value: 'action',
                align: 'center',
                width: '10%',
                sortable: false
            },
            {
                text: 'Estado',
                value: 'estado',
                align: 'center',
                width: '10%',
                sortable: false
            },
            {
                text: 'Cluster',
                value: 'cluster',
                align: 'center',
                width: '10%',
                sortable: false
            },
            {
                text: 'Organización',
                value: 'nombre',
                align: 'center',
                sortable: true,
                filterable: true,
            },
            {
                text: 'Cédula Jurídica',
                value: 'cedulaJur',
                align: 'center',
                sortable: true,
                filterable: true,
            },
            {
                text: 'Teléfono',
                value: 'telefono',
                align: 'center',
                sortable: true,
                filterable: true,
            },
            /*{
                text: 'Estructura Legal',
                value: 'nombreEstructura',
                align: 'center',
                sortable: true,
                filterable: true,
            },*/
            {
                text: 'Sector Productivo',
                value: 'nombreSector',
                align: 'center',
                sortable: true,
                filterable: true,
            },
            /*{
                text: 'Política Operatica',
                value: 'nombrePolitica',
                align: 'center',
                sortable: true,
                filterable: true,
            },*/
            {
                text: 'Correo',
                value: 'correo',
                align:'center',
                sortable: true,
                filterable: true,
            },
            {
                text: 'Ubicación',
                value: 'ubicacion',
                align:'center',
                sortable: true,
                filterable: true,
            },
        ],
        search: '',
        organizaciones: [],
        cargando: false
    }),
    methods: {
        listarOrganizaciones() {
            this.cargando = true;
            axios.get("/organizacion/listarOrganizaciones").then(response => {
                this.organizaciones = response.data.organizaciones;   
                this.cargando = false;
            }).catch(error => {
              if (error.request && error.request.status === 401) {
                this.$store.commit('showSessionDialog', true);
              } else {
                console.log(error);
                this.cargando = false;
              }
            })
        },
        alturaHoja() {
            return this.$mq === 'sm' ? 110 : 80;
        }
    }
};
</script>

<style scoped>
    table.v-table thead th {
      font-size: 20px !important;
    }

  .v-sheet--offset {
    top: -24px;
    position: relative;
  }
</style>